import logo from './logo.svg';
import React, { useEffect, useState } from 'react';
import './App.css';
import { HashRouter as Router, Route, Routes, Navigate, useParams, Outlet } from 'react-router-dom';
import EmployeeSelectionOrder from './EmployeeSelectionOrder';
import ManagersView from './ManagersView';
import Login from './login';
import { useNavigate } from 'react-router-dom';
import useAuthCheck from './useAuthCheck';
import apiConfig from './config/apiConfig';
import AdminLogin from './admin/AdminLogin';
import AdminLayout from './admin/AdminLayout';
import DisbursementManager from './admin/DisbursementManager';
import WelcomeLetterManager from './admin/WelcomeLetterManager';
import InventoryManager from './admin/InventoryManager';
import WinnersManager from './admin/WinnersManager';
import SupervisorQualManager from './admin/SupervisorQualManager';
import EmployeeQualManager from './admin/EmployeeQualManager';
import LoadEmployeesManager from './admin/LoadEmployeesManager';
import OrderProcessingManager from './admin/OrderProcessingManager';
import HistoricReportsManager from './admin/HistoricReportsManager';
import SwagItemsManager from './admin/SwagItemsManager';
import ProgramYearManager from './admin/ProgramYearManager';
import DrawingManager from './admin/DrawingManager';
import RightsManager from './admin/RightsManager';
import AdminPlaceholder from './admin/AdminPlaceholder';

function App() {
    const [authenticated, setAuthenticated] = useState(false);
    const [currentEmployeeID, setCurrentEmployeeID] = useState(null);

    // HashRouter routes via the URL hash; the /SIP subfolder is handled by nginx
    // + PUBLIC_URL (asset paths), so the Router needs no basename. Setting one to
    // PUBLIC_URL ("/SIP") makes HashRouter render nothing (blank page).

    // If the user lands on /SIP/admin (no hash), forward them to the admin login.
    // nginx already serves /SIP/index.html for any /SIP/* path, so the React app
    // boots; we just nudge the hash so HashRouter lands on the right page.
    useEffect(() => {
        if (apiConfig.isSIP) {
            const path = window.location.pathname.toLowerCase();
            const hash = window.location.hash;
            if (path.includes('/admin') && (!hash || hash === '#/' || hash === '#')) {
                window.location.hash = '#/admin/login';
            }
        }
    }, []);
  
   
    const checkManagerPermissions = (managersEmployeeID, employeeID) => {
        const jsonData = localStorage.getItem('managersEmployees');
        const responseData = JSON.parse(jsonData);

        if (Array.isArray(responseData) && responseData.length > 0) {
            // Find the employee in the manager's employees array
            const exists = responseData.some(employee => String(employee.employeeID) === String(employeeID));
            return exists;           
        }
        return false; 
       
    };
    function EmployeeSelectionOrderWrapper(props) {
        const { employeeID } = useParams();
        // If the employeeID from the URL doesn't match the authenticated user's ID, redirect them    

        
        if (employeeID != currentEmployeeID ) {

            return <Navigate to="/" />;
        }       

        return <EmployeeSelectionOrder {...props} />;
    }
    function ManagerEmployeeSelectionOrderWrapper() {
        const { managersEmployeeID, employeeID } = useParams();
        // Logic to check if managersEmployeeID matches the authenticated manager's ID and if they have the necessary permissions
        if (managersEmployeeID !== currentEmployeeID || !checkManagerPermissions(managersEmployeeID, employeeID)) {

            return <Navigate to="/" />;
        }

        return <EmployeeSelectionOrder employeeID={employeeID} />;
    }
    function ProtectedRoute({ children }) {
        console.log("authenticated at route ", authenticated);
        return authenticated ? children : <Navigate to="/" />;
    }
    
    const PrivateRoute = () => {

        const id = localStorage.getItem('currentEmployeeID');
        useAuthCheck(id); // Check the auth state
        const token = localStorage.getItem('auth_token');
        return token ? <Outlet /> : <Navigate to="/" replace />;
      };

    const AdminPrivateRoute = () => {
        const adminToken = localStorage.getItem('admin_auth_token');
        return adminToken ? <Outlet /> : <Navigate to="/admin/login" replace />;
    };
      
    return (
        <Router>
            <Routes>
         
                <Route path="/" element={<Login />} />
                <Route element={<PrivateRoute/>}>
                    
                    <Route path="/EmployeeSelection/:programYear/:employeeID" element={<EmployeeSelectionOrder />} />
                    <Route path="/EmployeeSelection/:programYear/:managersEmployeeID/:employeeID" element={<EmployeeSelectionOrder />} />
                    {!apiConfig.isSIP && (
                        <Route path="/ManagersView/:programYear/:managersEmployeeID" element={<ManagersView />} />
                    )}
                </Route>
                {apiConfig.isSIP && (
                    <Route path="/admin/login" element={<AdminLogin />} />
                )}
                {apiConfig.isSIP && (
                    <Route element={<AdminPrivateRoute />}>
                        <Route element={<AdminLayout />}>
                            <Route path="/admin" element={<Navigate to="/admin/disbursement" replace />} />
                            <Route path="/admin/disbursement" element={<DisbursementManager />} />
                            <Route path="/admin/welcome-letters" element={<WelcomeLetterManager />} />
                            <Route path="/admin/winners" element={<WinnersManager />} />
                            <Route path="/admin/inventory" element={<InventoryManager />} />
                            <Route path="/admin/supervisor-qual" element={<SupervisorQualManager />} />
                            <Route path="/admin/employee-qual" element={<EmployeeQualManager />} />
                            {/* Phase 2 scaffolding — built out in later phases */}
                            <Route path="/admin/drawing" element={<DrawingManager />} />
                            <Route path="/admin/load-employees" element={<LoadEmployeesManager />} />
                            <Route path="/admin/swag-items" element={<SwagItemsManager />} />
                            <Route path="/admin/order-processing" element={<OrderProcessingManager />} />
                            <Route path="/admin/reports" element={<HistoricReportsManager />} />

                            {/* Annual (original) swag program — shells until each is built */}
                            <Route path="/admin/annual/program-year" element={<ProgramYearManager />} />
                            <Route path="/admin/annual/load-employees" element={<AdminPlaceholder title="Annual Swag — Load Employees" note="Load the year's employee roster. Active status is tracked here and is independent of SIP. Coming soon." />} />
                            <Route path="/admin/annual/availability" element={<AdminPlaceholder title="Annual Swag — Swag Availability" note="Choose which swag items are available this program year (ProgramYearSwagItems). Coming soon." />} />
                            <Route path="/admin/annual/welcome-letters" element={<AdminPlaceholder title="Annual Swag — Welcome Letters" note="Print the per-employee welcome letters managers hand to their teams. Coming soon." />} />
                            <Route path="/admin/annual/reports" element={<AdminPlaceholder title="Annual Swag — Order Reports" note="POs grouped by branch and by distribution contact, plus order summaries. Coming soon." />} />
                            <Route path="/admin/annual/signoff" element={<AdminPlaceholder title="Annual Swag — Sign-off Sheet" note="Receipt sign-off sheet, logged back so we know everyone got their items. Coming soon." />} />
                            <Route path="/admin/annual/errors" element={<AdminPlaceholder title="Annual Swag — Error Log" note="Track order errors and how they were resolved. Coming soon." />} />
                            <Route path="/admin/rights" element={<RightsManager />} />
                        </Route>
                    </Route>
                )}
                <Route path="*" element={<Navigate to="/Login" replace   />} />
            </Routes>         
        </Router>
  );
}

export default App;
